import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getSearchResultValue as getValue } from '@zurich/search/utils';
import { ResultCardContentStyled, ResultCardStyled, } from '@zurich/ui/legacy/components';
import { ResultCardClaimContent } from './ResultCardClaimContent';
import { ResultCardClaimHeader } from './ResultCardClaimHeader';
export const ResultCardClaim = ({ result, searchValue, size, active, TitleWrapComponent, }) => {
    const claimNo = getValue(result, 'claimNo');
    const policyHolderPartnerNr = getValue(result, 'policyHolderPartnerNr');
    if (!claimNo || !policyHolderPartnerNr) {
        return null;
    }
    const WrapComponent = TitleWrapComponent ?? (({ children }) => _jsx(_Fragment, { children: children }));
    const isSmall = size === 'small';
    return (_jsx(ResultCardStyled, { active: active, tabIndex: 0, role: "button", "data-name": "search-result-card-claims", children: _jsxs(ResultCardContentStyled, { children: [_jsx(ResultCardClaimHeader, { isSmall: isSmall, TitleWrapComponent: WrapComponent, result: result, searchValue: searchValue }), _jsx(ResultCardClaimContent, { isSmall: isSmall, result: result, searchValue: searchValue })] }) }));
};
